import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit'
import axios, { AxiosError } from 'axios'

interface NavigationInitialStateType {
  data: any
  loading: boolean
  status: number | null
  errorStatus: number | null
}

const initialState: NavigationInitialStateType = {
  data: [{
    name: "",
    hash: "",
    icon: ""
  }],
  loading: false,
  status: null,
  errorStatus: null
}

const apiUrl = process.env.REACT_APP_API_BASE_URL;

const getNavigation = createAsyncThunk('NavigationSlice/getNavigation', async (_, thunkApi) => {
  try {
    const response = await axios.get(apiUrl + '/navigations')
    const data = await response.data.data.navigations
    return thunkApi.fulfillWithValue(data)
  } catch (error) {
    const err = error as AxiosError
    return thunkApi.rejectWithValue(err.response?.status)
  }
})

const NavigationSlice = createSlice({
  name: "NavigationSlice",
  initialState,
  reducers: {
    getValue: (state, action) => {
      state.data = action.payload
    },
    resetValue: (state) => {
      state.data = [{ name: "", hash: "", icon: "" }]
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getNavigation.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getNavigation.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getNavigation.rejected, (state, action) => {
      state.errorStatus = action.payload as number
    })
    builder.addMatcher(isAnyOf(
      getNavigation.fulfilled, getNavigation.rejected), (state) => {
        state.loading = false
      })
  }
})

const NavigationThunks = {
  getNavigation,
}

export const NavigationServices = {
  ...NavigationThunks,
  actions: NavigationSlice.actions,
}

const NavigationReducer = NavigationSlice.reducer
export default NavigationReducer